// styles
import "../themes/common.scss";
import "../themes/css/pages/life-insurance.scss";
//js
import "../themes/js/common.js";
import "../themes/js/pages/life-insurance.js"
import { initmanage } from "../javascripts/component/manage.js";

initmanage();

